module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row small-up-2 medium-up-3 large-up-3 grid"
  }, _vm._l((_vm.faces), function(face) {
    return _c('div', {
      staticClass: "column column-block"
    }, [_c('face', {
      attrs: {
        "face": face,
        "title-description": _vm.titleDescription
      }
    })], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-420c1582"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FaceBlockGrid.vue
// module id = 13
// module chunks = 0 1 2 3 4